import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { differenceInCalendarDays } from 'date-fns';
import { setAppState } from '../../appSlice';

export default function useEducationalMessages() {
  const dispatch = useDispatch();
  const onboarding = useSelector((state) => state.onboarding);
  const {
    show: showOnboarding,
    formV2: { who: selectedWhoTypeV2 },
    capacityTooltip,
  } = onboarding;

  // Guest filter tooltip logic
  useEffect(() => {
    const storedCapacity = JSON.parse(localStorage.getItem('familyCapacityDetails'));
    const acceptableTypes = ['family', 'friends'];
    const hfLastFilters = JSON.parse(localStorage.getItem('hfLastFilters'));

    const shouldShowGuestFilterTooltip =
      (acceptableTypes.includes(selectedWhoTypeV2?.id)) &&
      !(hfLastFilters && hfLastFilters?.engine?.who?.adult) &&
      !showOnboarding &&
      (!storedCapacity || differenceInCalendarDays(new Date(), new Date(storedCapacity.timestamp)) > 30) &&
      capacityTooltip;

    if (shouldShowGuestFilterTooltip) {
      const timeoutId = setTimeout(() => {
        dispatch(setAppState({ guestFilterTooltip: true }));
      }, 1000);

      return () => clearTimeout(timeoutId);
    }

    if (storedCapacity) {
      localStorage.removeItem('familyCapacityDetails');
    }
  }, [dispatch, selectedWhoTypeV2, showOnboarding]);

  return null;
}
